import { type ExtensionConfig, PrerequisiteRuleTypes } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@goto/onboarding',
  esModule: true,
  get url() {
    const version = getFeatureFlag('shell-extensions-onboarding-version', 'latest')
    return new URL(`experiences/shell-extensions/${version}/onboarding/index.js`, location.origin)
  },
  prerequisites: { [PrerequisiteRuleTypes.SHELL_FEATURE_FLAGS]: 'enable-onboarding' },
}

export default extensionConfig
